import { apiClient } from "@/api/api-client.ts";
import createBaseService from "@/api/base-service.ts";
import type { Notification } from "@/features/dashboard/types/notification.ts";

const notificationService = {
	...createBaseService<Notification>("/notifications"),
	readNotifications: async () => {
		await apiClient.post("/read_notifications");
	},
	unreadNotifications: async () => {
		const response = await apiClient.get<{
			data: {
				unread_count: number;
			};
		}>("/unread_notifications");

		return response.data.data;
	},
};

export default notificationService;
